import { getByZip } from 'zcs';
import states from 'us-state-converter';

import moment from 'moment';
import { COMPANY_TYPES, COUNTRIES, INTEGRATIONS, SUBSCRIPTION_STATUSES } from './company.constants';

export const isPersonal = (company) => company?.type === COMPANY_TYPES.PERSONAL;
export const isCorporate = (company) => company?.type === COMPANY_TYPES.CORPORATE;

export const isCanadianCompany = (company) => company?.country === COUNTRIES.CANADA;
export const isUSCompany = (company) => company?.country === COUNTRIES.UNITED_STATES;

// -> start subscription helpers
export const isTrialing = (company) => wasNeverSubscribed(company) && !!company?.trial_expires_on && moment(company.trial_expires_on).isAfter(moment());

export const isTrialExpired = (company) =>  !!company?.trial_expires_on && moment(company.trial_expires_on).isBefore(moment());

export const wasNeverSubscribed = (company) => !company?.subscription_status;

export const isSubscribed = (company) => !!company?.subscription_status && company.subscription_status !== SUBSCRIPTION_STATUSES.CANCELED;

export const isSubscriptionWillBeCanceled = (company) => !!company?.subscription_status
  && company.subscription_status === SUBSCRIPTION_STATUSES.CANCEL_AT_PERIOD_END;

export const isSubscriptionCanceled = (company) => !!company?.subscription_status
  && company.subscription_status === SUBSCRIPTION_STATUSES.CANCELED;
// <- end subscription helpers

export const isEsignatureEnabled = (company) => !!company?.integrations?.includes(INTEGRATIONS.ESIGNATURE);

export const getCityAndStateValueByZip = (companyZip) => {
  if (!companyZip) {
    return null;
  }

  let res = null;

  try {
    res = getByZip(companyZip);
  } catch (e) {
    return null;
  }

  if (!res?.city || !res?.state) {
    return null;
  }

  return `${res.city}, ${states.fullName(res.state)}`;
};

export const daysLeftOnTrial = (company) => {
  return isTrialing(company)
    ? moment(company.trial_expires_on).diff(moment(), 'days') + 1 // add 1 to include the current day
    : 0;
}
